var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"md":"12","id":"checkout-page"}},[_c('Header'),_c('SelectPayment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }